import { render } from "./Teaser.vue?vue&type=template&id=70355615&scoped=true"
import script from "./Teaser.vue?vue&type=script&lang=js"
export * from "./Teaser.vue?vue&type=script&lang=js"

import "./Teaser.vue?vue&type=style&index=0&id=70355615&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70355615"]])

export default __exports__